import { render, staticRenderFns } from "./create-product.html?vue&type=template&id=452c4f40&scoped=true&external"
import script from "./create-product.js?vue&type=script&lang=js&external"
export * from "./create-product.js?vue&type=script&lang=js&external"
import style0 from "./create-product.scss?vue&type=style&index=0&id=452c4f40&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c4f40",
  null
  
)

export default component.exports